export default __webpack_public_path__ + "static/media/PasswordIcon.158b5025.svg";